import React from "react";
import { Navigate, Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import Layout from "../components/layouts/Layout";
import { useTranslation } from "react-i18next";

type Props = {
  children: React.ReactNode;
  ownerOnly?: boolean;    // page accessible only by owner
  requireStore?: boolean; // page requires a store token
  redirectLink?: string;
};

function ProtectedRouteOwner({ children, ownerOnly = false, requireStore = false, redirectLink }: Props) {
  const ownerToken = useSelector((state: RootState) => state.owner.accessToken);
  const storeToken = useSelector((state: RootState) => state.store.accessToken);
  const location = useLocation();
  const { t } = useTranslation();

  const currentPath = encodeURIComponent(location.pathname + location.search);

  // Neither owner nor store → redirect to login with redirect param
  if (!ownerToken && !storeToken) {
    return (
      <Navigate
        to={redirectLink ? redirectLink : `/?redirect=${currentPath}`}
        replace
      />
    );
  }

  // Owner-only page
  if (ownerOnly && !ownerToken) {
    return <Navigate to={`/?redirect=${currentPath}`} replace />;
  }

  // Page requires store token
  if (requireStore && !storeToken) {
    return (
      <Layout title="" headline="">
        <div className="flex flex-col items-center justify-center text-center p-6 h-[70vh]">
          <h2 className="text-2xl font-bold text-Black mb-4">{t("no_store_selected")}</h2>
          <p className="text-DarkGrey3 mb-6">{t("please_select_store")}</p>
          <Link
            to="/owner/stores"
            className="px-6 py-3 bg-primaryButton text-white rounded-lg shadow hover:bg-primary/90"
          >
            {t("go_to_stores")}
          </Link>
        </div>
      </Layout>
    );
  }

  return <>{children}</>;
}

export default ProtectedRouteOwner;
